// @flow
import type { ElementConfig } from 'react';
import React, { useRef } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import { MQ } from '@rover/kibble/styles';
import SelectButton from '@rover/react-lib/components/buttons/SelectButton';
import { getNextId } from '@rover/react-lib/utils/elementIdCreator';

type WrapperProps = {
  isVertical: boolean,
};

const Wrapper: StyledComponent<WrapperProps> = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.isVertical ? 'column' : '')};
`;

type StyledSelectButtonProps = {
  ...React$ElementConfig<typeof SelectButton>,
  isVertical?: boolean,
};

export const StyledSelectButton: StyledComponent<StyledSelectButtonProps> = styled(SelectButton)`
  &:not(:first-of-type) {
    margin-top: ${(props) => (props.isVertical ? '12px' : '')};
    margin-left: ${(props) => (props.isVertical ? '0' : '')};
  }

  ${MQ.MD_UP} {
    max-width: 50%;
  }
`;

export type Props = {
  value: any,
  buttons: Array<ElementConfig<typeof StyledSelectButton>>,
  onChange: (any) => void,
  inputGroupName?: string,
  isVertical?: boolean,
};

const SingleSelectButtonGroup = ({ value, buttons, onChange, isVertical, ...other }: Props) => {
  const defaultInputGroupName = useRef(getNextId()).current;
  return (
    <Wrapper {...other} isVertical={isVertical} role="radiogroup">
      {buttons.map((button) => (
        <StyledSelectButton
          {...button}
          isVertical={isVertical}
          key={button.value}
          selected={button.value === value && !button.disabled}
          onClick={() => onChange(button.value)}
          allowSelectMultiple={false}
          inputGroupName={other.inputGroupName || defaultInputGroupName}
        />
      ))}
    </Wrapper>
  );
};

SingleSelectButtonGroup.defaultProps = {
  isVertical: false,
};

export default SingleSelectButtonGroup;



// WEBPACK FOOTER //
// ../react-lib/src/components/formFields/SingleSelectButtonGroup/SingleSelectButtonGroup.jsx